/* ============================================================
   Ogé Exclusive, scroll reveal controller
   Reveals authored `.oge-reveal` / `.oge-stagger` elements and,
   for stock Horizon sections that contain none, falls back to
   revealing the whole section. Anti-FOUC: elements already in
   view on load are revealed immediately (no flash). Respects
   reduced motion and degrades to fully-visible if JS/observer
   is absent.
   ============================================================ */
(function () {
  'use strict';

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var AUTHORED = '.oge-reveal, .oge-stagger';

  function init() {
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!main) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('oge-in');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    var vh = window.innerHeight || document.documentElement.clientHeight;

    function register(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.92) {
        // Already visible on load → show immediately, no flash.
        el.classList.add('oge-in');
      } else {
        observer.observe(el);
      }
    }

    // Bespoke sections mark their own reveal targets.
    main.querySelectorAll(AUTHORED).forEach(register);

    // Stock sections without authored targets reveal as a whole.
    main.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.querySelector(AUTHORED)) return;
      section.classList.add('oge-reveal');
      register(section);
    });

    // Failsafe: content that never intersects (late-hydrated sections,
    // a missed observer callback) must not stay invisible forever.
    setTimeout(function () {
      main.querySelectorAll('.oge-reveal:not(.oge-in), .oge-stagger:not(.oge-in)').forEach(function (el) {
        el.classList.add('oge-in');
      });
      observer.disconnect();
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();

/* Hero video: starts after the page load, so the poster image is the LCP
   element and the film never competes with it for bandwidth. Skipped for
   data-saver users; they keep the poster. */
(function () {
  'use strict';

  function start() {
    var videos = document.querySelectorAll('[data-oge-hero-video]');
    if (!videos.length) return;
    // Only data-saver users keep the poster. Reduced motion no longer
    // stops the film (28 okt 2026): macOS "Beweging verminderen" is on for
    // many people, Safari and Chrome both pass it on, and the client saw a
    // dead banner on every machine with that setting.
    var saveData = navigator.connection && navigator.connection.saveData;
    if (saveData) return;

    var pending = [];

    function tryPlay(video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    videos.forEach(function (video) {
      if (!video.offsetParent) return;
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      }, { once: true });
      video.preload = 'auto';
      // Safari: let the browser own autoplay too. It then starts the film
      // itself as soon as its own rules allow it (tab visible, enough data,
      // not in low power mode), instead of relying on one play() call.
      video.autoplay = true;
      video.muted = true;
      video.addEventListener('canplay', function () {
        if (video.paused) tryPlay(video);
      }, { once: true });
      tryPlay(video);
      pending.push(video);
    });

    // Safari refuses play() without a gesture in low power mode or with
    // auto-play set to "never". The first scroll, tap or click counts as
    // one, so retry once on that; the poster stays until then.
    function retry() {
      pending.forEach(function (video) {
        if (video.paused) tryPlay(video);
      });
    }
    ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (type) {
      window.addEventListener(type, retry, { once: true, passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) retry();
    });
  }

  var started = false;
  function schedule() {
    if (started) return;
    started = true;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(start, { timeout: 2000 });
    } else {
      setTimeout(start, 200);
    }
  }

  // Start as soon as the poster (the LCP image) is in, and at the latest a
  // few seconds after the DOM is ready. Waiting for `load` alone was not
  // enough: one slow third-party request keeps `load` from firing and
  // Chrome then showed a still banner for as long as that request hung.
  function armPoster() {
    var poster = document.querySelector('[data-testid="hero-desktop-poster-1"], .hero__media-wrapper img.hero__media');
    if (poster && poster.complete) {
      schedule();
    } else if (poster) {
      poster.addEventListener('load', schedule, { once: true });
      poster.addEventListener('error', schedule, { once: true });
    }
    setTimeout(schedule, 3000);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armPoster);
    } else {
      armPoster();
    }
  }
})();
